export class ApiService {
	constructor() {

	}

	increaseWebinarCounter(webinarUid, property) {
		let url = window.location.origin + '/api/webinar-click/' + webinarUid + '/' + property + '/';
		this.get(url);
	}

	get(url, successCallback, errorCallback) {
		fetch(url)
			.then(response => {
				if (response.status === 403) {
					if (typeof errorCallback === 'function') {
						errorCallback()
					}
				} else {
					successCallback(response.text())
				}
			})
			.catch((error) => {
				if (typeof errorCallback === 'function') {
					errorCallback(error)
				}
			});
	}
}
